// Batch Y — Master Keywords absorb (2026_Master_Keywords.docx)
// Focus: interpreting, premium/specialist translation, notarial + legalization
// chains, and one-stop B2B/expat packages (visa · BOI · licences).
// Zero AI credit — hand-written A5 answers, 25–55 words, entity-dense,
// non-duplicative with existing notary / naati / apostille / visa pools.
import { CORPORATE_BOI_DEPTH_D_FAQS } from "@/data/corporate-boi-depth-d-absorb";
import { EDUCATION_CREDENTIAL_DEPTH_E_FAQS } from "@/data/education-credential-depth-e-absorb";
import { POLICE_CLEARANCE_DEPTH_D_FAQS } from "@/data/police-clearance-depth-d-absorb";
import { IP_TRADEMARK_DEPTH_D_FAQS } from "@/data/ip-trademark-depth-d-absorb";
import { FRANCHISE_DISTRIBUTION_DEPTH_D_FAQS } from "@/data/franchise-distribution-depth-d-absorb";
import { MARITIME_SHIPPING_DEPTH_D_FAQS } from "./maritime-shipping-depth-d-absorb";
import { AVIATION_AEROSPACE_DEPTH_D_FAQS } from "./aviation-aerospace-depth-d-absorb";
import { NONPROFIT_NGO_DEPTH_D_FAQS } from "./nonprofit-ngo-depth-d-absorb";
import { SPORTS_ESPORTS_DEPTH_D_FAQS } from "./sports-esports-depth-d-absorb";
import { AGRICULTURE_FOOD_DEPTH_D_FAQS } from "./agriculture-food-depth-d-absorb";
import { STARTUP_VC_DEPTH_D_FAQS } from "./startup-vc-depth-d-absorb";
import { ENERGY_RENEWABLES_DEPTH_D_FAQS } from "@/data/energy-renewables-depth-d-absorb";
import { BANKING_FINANCE_KYC_DEPTH_FAQS } from "@/data/banking-finance-kyc-depth-absorb";
import { CIVILREG_TELECOM_DEPTH_FAQS } from "@/data/civilreg-telecom-depth-absorb";
import { PROPERTY_MINING_CHEM_DEPTH_FAQS } from "@/data/property-mining-chem-depth-absorb";
import { RETAIL_FRANCHISE_MEDIA_DEPTH_FAQS } from "@/data/retail-franchise-media-depth-absorb";
import { ENERGY_CONSTRUCTION_DEPTH_FAQS } from "@/data/energy-construction-depth-absorb";
import { LITIGATION_COURT_DEPTH_B_FAQS } from "@/data/litigation-court-depth-b-absorb";
import { IP_PDPA_DEPTH_B_FAQS } from "@/data/ip-pdpa-depth-b-absorb";
import { MFA_CONSULAR_DEPTH_B_FAQS } from "@/data/mfa-consular-depth-b-absorb";
import { CORPORATE_BOI_DEPTH_B_FAQS } from "@/data/corporate-boi-depth-b-absorb";
import { RETAIL_MEDIA_DEPTH_B_FAQS } from "@/data/retail-media-depth-b-absorb";
import { INSURANCE_CLAIMS_DEPTH_B_FAQS } from "@/data/insurance-claims-depth-b-absorb";
import { TAX_CUSTOMS_DEPTH_B_FAQS } from "@/data/tax-customs-depth-b-absorb";
import { MARITIME_AVIATION_DEPTH_B_FAQS } from "@/data/maritime-aviation-depth-b-absorb";
import { DRIVING_TRANSPORT_DEPTH_B_FAQS } from "@/data/driving-transport-depth-b-absorb";
import { POLICE_CLEARANCE_DEPTH_B_FAQS } from "@/data/police-clearance-depth-b-absorb";
import { MARRIAGE_FAMILY_DEPTH_B_FAQS } from "@/data/marriage-family-depth-b-absorb";
import { REALESTATE_LAND_DEPTH_B_FAQS } from "@/data/realestate-land-depth-b-absorb";
import { MEDICAL_HEALTH_DEPTH_B_FAQS } from "@/data/medical-health-depth-b-absorb";
import { BANKING_FINANCE_DEPTH_B_FAQS } from "@/data/banking-finance-depth-b-absorb";
import { NAATI_DEPTH_D_FAQS } from "@/data/naati-depth-d-absorb";
import { PROVINCIAL_SERVICE_DEPTH_B_FAQS } from "@/data/provincial-service-depth-b-absorb";
import { EGP_PROCUREMENT_DEPTH_D_FAQS } from "@/data/egp-procurement-depth-d-absorb";
import { NAATI_DEPTH_E_FAQS } from "@/data/naati-depth-e-absorb";
import { NAATI_DEPTH_F_FAQS } from "@/data/naati-depth-f-absorb";
import { PROVINCIAL_SERVICE_DEPTH_D_FAQS } from "@/data/provincial-service-depth-d-absorb";
import { PROPERTY_MINING_CHEM_DEPTH_B_FAQS } from "@/data/property-mining-chem-depth-b-absorb";
import { PROVINCIAL_SERVICE_DEPTH_C_FAQS } from "@/data/provincial-service-depth-c-absorb";
import { EGP_PROCUREMENT_DEPTH_E_FAQS } from "@/data/egp-procurement-depth-e-absorb";
import { EGP_PROCUREMENT_DEPTH_F_FAQS } from "@/data/egp-procurement-depth-f-absorb";
import { SERVICE_PROCEDURE_PLAYBOOK_C_FAQS } from "@/data/service-procedure-playbook-c-absorb";
import { LOGISTICS_CUSTOMS_DEPTH_D_FAQS } from "@/data/logistics-customs-depth-d-absorb";
import { INSURANCE_CLAIMS_DEPTH_D_FAQS } from "@/data/insurance-claims-depth-d-absorb";
import { LITIGATION_ARBITRATION_DEPTH_D_FAQS } from "@/data/litigation-arbitration-depth-d-absorb";
import { MEDICAL_HEALTH_DEPTH_D_FAQS } from "@/data/medical-health-depth-d-absorb";
import { BANKING_KYC_DEPTH_D_FAQS } from "@/data/banking-kyc-depth-d-absorb";
import { TELECOM_DIGITAL_DEPTH_D_FAQS } from "@/data/telecom-digital-depth-d-absorb";
import { ENERGY_CONSTRUCTION_DEPTH_C_FAQS } from "@/data/energy-construction-depth-c-absorb";
import { MINING_CHEMICALS_DEPTH_C_FAQS } from "@/data/mining-chemicals-depth-c-absorb";
import { EGP_PROCUREMENT_DEPTH_C_FAQS } from "@/data/egp-procurement-depth-c-absorb";
import { LOGISTICS_CUSTOMS_DEPTH_C_FAQS } from "@/data/logistics-customs-depth-c-absorb";
import { EDUCATION_CREDENTIAL_DEPTH_C_FAQS } from "@/data/education-credential-depth-c-absorb";
import { TELECOM_DIGITAL_DEPTH_C_FAQS } from "@/data/telecom-digital-depth-c-absorb";
import { NOTARY_CORE_DEPTH_C_FAQS } from "@/data/notary-core-depth-c-absorb";
import { APOSTILLE_HCCH_DEPTH_C_FAQS } from "@/data/apostille-hcch-depth-c-absorb";
import { CERTIFIED_TRANSLATION_NAATI_DEPTH_C_FAQS } from "@/data/certified-translation-naati-depth-c-absorb";
import { POLICE_CLEARANCE_DEPTH_C_FAQS } from "@/data/police-clearance-depth-c-absorb";
import { VISA_IMMIGRATION_DEPTH_C_FAQS } from "@/data/visa-immigration-depth-c-absorb";
import { MARRIAGE_FAMILY_DEPTH_C_FAQS } from "@/data/marriage-family-depth-c-absorb";
import { CIVIL_REGISTRATION_DEPTH_C_FAQS } from "@/data/civil-registration-depth-c-absorb";
import { REALESTATE_LAND_DEPTH_C_FAQS } from "@/data/realestate-land-depth-c-absorb";
import { LITIGATION_ARBITRATION_DEPTH_C_FAQS } from "@/data/litigation-arbitration-depth-c-absorb";
import { MEDICAL_HEALTH_DEPTH_C_FAQS } from "@/data/medical-health-depth-c-absorb";
import { BANKING_KYC_DEPTH_C_FAQS } from "@/data/banking-kyc-depth-c-absorb";
import { INSURANCE_CLAIMS_DEPTH_C_FAQS } from "@/data/insurance-claims-depth-c-absorb";
import { SERVICE_PROCEDURE_PLAYBOOK_FAQS } from "@/data/service-procedure-playbook-absorb";
import { TAX_CUSTOMS_DEPTH_C_FAQS } from "@/data/tax-customs-depth-c-absorb";
import { LABOUR_HR_DEPTH_C_FAQS } from "@/data/labour-hr-depth-c-absorb";
import { EDUCATION_CREDENTIAL_DEPTH_D_FAQS } from "@/data/education-credential-depth-d-absorb";
import { SERVICE_PROCEDURE_PLAYBOOK_B_FAQS } from "@/data/service-procedure-playbook-b-absorb";
import { LABOUR_HR_DEPTH_B_FAQS } from "@/data/labour-hr-depth-b-absorb";
import { CIVILREG_PROPERTY_DEPTH_B_FAQS } from "@/data/civilreg-property-depth-b-absorb";
import { STUDY_ABROAD_ADMISSION_DEPTH_FAQS } from "@/data/study-abroad-admission-depth-absorb";
import { IT_IP_TECH_FAQS } from "@/data/it-ip-tech-depth-absorb";
import { NOTARY_PUBLIC_DEPTH_FAQS } from "@/data/notary-public-depth-absorb";
import { OVERSEAS_EMPLOYMENT_SEAFARER_FAQS } from "@/data/overseas-employment-seafarer-depth-absorb";
import { EAPOSTILLE_DIGITAL_DOCS_FAQS } from "@/data/eapostille-digital-docs-depth-absorb";
import { ORDER_PROCESS_QUALITY_FAQS } from "@/data/order-process-quality-depth-absorb";
import { THAI_NATIONALS_ABROAD_FAQS } from "@/data/thai-nationals-abroad-depth-absorb";
import { FOREIGN_RESIDENTS_THAILAND_FAQS } from "@/data/foreign-residents-thailand-depth-absorb";
import { CREDENTIAL_RECOGNITION_FAQS } from "@/data/credential-recognition-depth-absorb";
import { PROVINCIAL_COVERAGE_FAQS } from "@/data/provincial-coverage-depth-absorb";
import { EGP_PROCUREMENT_DEPTH_FAQS } from "@/data/egp-procurement-depth-absorb";
import { CIVILREG_PROPERTY_PDPA_DEPTH_FAQS } from "@/data/civilreg-property-pdpa-depth-absorb";
import { MFA_CONSULAR_DEPTH_FAQS } from "@/data/mfa-consular-depth-absorb";
import { LITIGATION_ARBITRATION_DEPTH_FAQS } from "@/data/litigation-arbitration-depth-absorb";
import { LABOUR_HR_WORKPERMIT_DEPTH_FAQS } from "@/data/labour-hr-workpermit-depth-absorb";
import { IP_PDPA_COMPLIANCE_DEPTH_FAQS } from "@/data/ip-pdpa-compliance-depth-absorb";
import { APOSTILLE_HCCH_COUNTRY_DEPTH_FAQS } from "@/data/apostille-hcch-country-depth-absorb";
import { REALESTATE_LANDOFFICE_DEPTH_FAQS } from "@/data/realestate-landoffice-depth-absorb";
import { REGIONAL_PROVINCE_DEPTH_FAQS } from "@/data/regional-province-depth-absorb";
import { EGP_BID_DOCS_DEPTH_FAQS } from "@/data/egp-bid-docs-depth-absorb";
import { HEALTHCARE_MEDICAL_TOURISM_DEPTH_FAQS } from "@/data/healthcare-medical-tourism-depth-absorb";
import { CHILD_GUARDIANSHIP_ADOPTION_DEPTH_FAQS } from "@/data/child-guardianship-adoption-depth-absorb";
import { EDUCATION_CREDENTIAL_DEPTH_B_FAQS } from "@/data/education-credential-depth-b-absorb";
import { LOGISTICS_CUSTOMS_DEPTH_B_FAQS } from "@/data/logistics-customs-depth-b-absorb";
import { INSURANCE_CLAIMS_DEPTH_FAQS } from "@/data/insurance-claims-depth-absorb";
import { PERSONAL_TAX_CUSTOMS_DEPTH_FAQS } from "@/data/personal-tax-customs-depth-absorb";
import type { VoiceFAQ } from "@/components/seo/VoiceSearchFAQ";
import { PROPERTY_INHERITANCE_FAQS } from "@/data/property-inheritance-depth-absorb";
import { FINANCE_TAX_FAQS } from "@/data/finance-banking-tax-depth-absorb";
import { LABOUR_HR_FAQS } from "@/data/labour-hr-depth-absorb";
import { LITIGATION_POA_FAQS } from "@/data/litigation-poa-depth-absorb";
import { LOGISTICS_CUSTOMS_FAQS } from "@/data/logistics-customs-depth-absorb";
import { IT_IP_FAQS } from "@/data/it-ip-depth-absorb";
import { ENERGY_CONSTRUCTION_INSURANCE_FAQS } from "@/data/energy-construction-insurance-depth-absorb";
import { EDUCATION_MEDICAL_FAQS } from "@/data/education-medical-depth-absorb";
import { AGRI_TOURISM_MEDIA_FAQS } from "@/data/agri-tourism-media-depth-absorb";
import { MARITIME_AVIATION_FAQS } from "@/data/maritime-aviation-depth-absorb";
import { ISLAMIC_NGO_SPORTS_FAQS } from "@/data/islamic-ngo-sports-depth-absorb";
import { CITIZENSHIP_PR_FAMILY_FAQS } from "@/data/citizenship-pr-family-depth-absorb";
import { PROPERTY_CHEM_MINING_FAQS } from "@/data/property-chem-mining-depth-absorb";
import { AUTOMOTIVE_TRANSPORT_FAQS } from "@/data/automotive-transport-depth-absorb";
import { RETAIL_ECOMMERCE_FAQS } from "@/data/retail-ecommerce-depth-absorb";
import { GOV_PROCUREMENT_FAQS } from "@/data/gov-procurement-egp-depth-absorb";
import { PROVINCIAL_SERVICE_FAQS } from "@/data/provincial-service-depth-absorb";
import { POLICE_CLEARANCE_FAQS } from "@/data/police-clearance-depth-absorb";
import { MARRIAGE_FAMILY_ABROAD_FAQS } from "@/data/marriage-family-abroad-depth-absorb";
import { PDPA_DIGITAL_ASSET_FAQS } from "@/data/pdpa-digitalasset-depth-absorb";
import { CIVILREG_INSURANCE_TELECOM_FAQS } from "@/data/civilreg-insurance-telecom-depth-absorb";
import { LANGUAGE_TRAINING_INTERPRETING_FAQS } from "@/data/language-training-interpreting-depth-absorb";
import { EMBASSY_COUNTRY_DESK_FAQS } from "@/data/embassy-country-desk-depth-absorb";
import { VISA_LONGSTAY_FAQS } from "@/data/visa-longstay-depth-absorb";
import { TRANSLATION_DOCTYPE_FAQS } from "@/data/translation-doctype-depth-absorb";
import { TAX_CUSTOMS_DEPTH_D_FAQS } from "./tax-customs-depth-d-absorb";
import { LABOUR_HR_DEPTH_D_FAQS } from "./labour-hr-depth-d-absorb";
import { NOTARY_CORE_DEPTH_D_FAQS } from "./notary-core-depth-d-absorb";
import { APOSTILLE_HCCH_DEPTH_D_FAQS } from "./apostille-hcch-depth-d-absorb";
import { VISA_IMMIGRATION_DEPTH_D_FAQS } from "./visa-immigration-depth-d-absorb";
import { MARRIAGE_FAMILY_DEPTH_D_FAQS } from "./marriage-family-depth-d-absorb";
import { MEDIA_ENTERTAINMENT_DEPTH_D_FAQS } from "./media-entertainment-depth-d-absorb";
import { MINING_RESOURCES_DEPTH_D_FAQS } from "./mining-resources-depth-d-absorb";
import { CONSTRUCTION_FIDIC_DEPTH_D_FAQS } from "./construction-fidic-depth-d-absorb";
import { INSURANCE_REINSURANCE_DEPTH_E_FAQS } from "./insurance-reinsurance-depth-e-absorb";
import { REAL_ESTATE_FOREIGN_DEPTH_D_FAQS } from "./real-estate-foreign-depth-d-absorb";
import { CUSTOMS_FTA_DEPTH_D_FAQS } from "./customs-fta-depth-d-absorb";
import { TEXTILE_APPAREL_DEPTH_D_FAQS } from "./textile-apparel-depth-d-absorb";
import { WASTE_RECYCLING_DEPTH_D_FAQS } from "./waste-recycling-depth-d-absorb";
import { WATER_UTILITIES_DEPTH_D_FAQS } from "./water-utilities-depth-d-absorb";
import { SPACE_SATELLITE_DEPTH_D_FAQS } from "./space-satellite-depth-d-absorb";
import { PORTS_FTZ_DEPTH_D_FAQS } from "./ports-ftz-depth-d-absorb";
import { RAIL_TRANSPORT_DEPTH_D_FAQS } from "./rail-transport-depth-d-absorb";
import { FISHERIES_AQUA_DEPTH_D_FAQS } from "./fisheries-aqua-depth-d-absorb";
import { DEFENSE_PROCUREMENT_DEPTH_D_FAQS } from "./defense-procurement-depth-d-absorb";
import { SEMICONDUCTOR_CHIP_DEPTH_D_FAQS } from "./semiconductor-chip-depth-d-absorb";
import { FORESTRY_TIMBER_DEPTH_D_FAQS } from "./forestry-timber-depth-d-absorb";

export const MASTER_ONESTOP_FAQS: VoiceFAQ[] = [
  // ── Interpreting (on-site · VRI · court · negotiation) ──────────────
  { q: "จ้างล่ามแปลภาษาในงานประชุม ราคาเท่าไหร่", a: "ล่ามพูดตาม (Consecutive) ไทย–อังกฤษ ครึ่งวัน ฿6,500 เต็มวัน ฿9,500 · ล่ามพูดพร้อม (Simultaneous) ต้องจัด 2 คนสลับ เริ่ม ฿18,000/วัน/คน รวมอุปกรณ์ตู้ล่ามคิดเพิ่มตามสถานที่ จองล่วงหน้า 5 วันทำการ" },
  { q: "how much is a conference interpreter in bangkok", a: "NYC quotes THB 6,500 per half-day and THB 9,500 per full day for consecutive Thai–English interpreting. Simultaneous booth work requires two interpreters from THB 18,000 each per day, plus equipment. Book five working days ahead for ASEAN-summit-scale events." },
  { q: "ล่ามศาล ล่ามสถานีตำรวจ เรียกใช้ได้ไหม", a: "ได้ NYC ส่งล่ามที่มีประสบการณ์กระบวนพิจารณา ทั้งชั้นสอบสวน สน. ศาลอาญา และศาลแรงงาน ค่าบริการเริ่ม ฿8,000 ต่อครึ่งวัน แจ้งล่วงหน้า 24 ชั่วโมงสำหรับกรณีเร่งด่วนกลางดึกมีค่าเรียกพิเศษ" },
  { q: "interpreter for police fingerprinting appointment", a: "Yes — an NYC coordinator plus interpreter accompanies you to the Royal Thai Police Criminal Records Division for FD-258 fingerprinting, explains each counter, and handles the receipt. Half-day escort from THB 5,500 including queue booking." },
  { q: "video remote interpreting corporate package", a: "NYC's VRI runs on Zoom, Teams, or Google Meet with a dedicated interpreter channel. Pay-as-you-go is THB 2,500 per hour; corporate subscriptions of 20 hours or more drop to THB 1,900 per hour with a named interpreter roster for term consistency." },
  { q: "ล่ามรัสเซีย ล่ามจีน ที่ภูเก็ต พัทยา มีไหม", a: "มี NYC มีเครือข่ายล่ามรัสเซีย จีน เกาหลี และอาหรับ ประจำภูเก็ต พัทยา และเชียงใหม่ ใช้ในงานเจรจาอสังหาริมทรัพย์ โอนคอนโด และประชุมนักลงทุน แจ้งล่วงหน้า 48 ชั่วโมง ค่าเดินทางคิดตามระยะจริง" },
  { q: "european language interpreter for embassy visa interview", a: "NYC supplies French, German, Italian, Spanish, and Dutch interpreters to accompany applicants at Bangkok embassy interviews where the mission permits a companion. Rate is THB 7,500 per appointment including one pre-interview briefing call." },

  // ── Sworn / MoJ / NAATI specialist translation ─────────────────────
  { q: "นักแปลสาบานตน สถานทูตฝรั่งเศส เยอรมนี หาที่ไหน", a: "NYC ทำงานร่วมกับนักแปลที่อยู่ในบัญชีสถานทูตฝรั่งเศส เยอรมนี อิตาลี สเปน สวิส เบลเยียม และออสเตรีย เอกสารสมรส รับรองบุตร และสัญญาธุรกิจ เริ่ม ฿1,200/หน้า ใช้เวลา 3–5 วันทำการ" },
  { q: "how long does a sworn translation for a schengen marriage visa take", a: "Plan on three to five working days for a sworn set: birth certificate, single-status certificate, house registration, and ID. Add two days if the embassy also requires MFA legalisation of the Thai originals first." },
  { q: "แปลสำนวนคดีและคำพิพากษาโดยนักแปลกระทรวงยุติธรรม", a: "NYC ใช้ผู้แปลขึ้นทะเบียนกระทรวงยุติธรรมสำหรับคำพิพากษา หมายจับ หมายเรียก สำนวนสอบสวน และพินัยกรรม เริ่ม ฿900/หน้า พร้อมตรารับรองที่ศาลและหน่วยงานต่างประเทศยอมรับ ใช้เวลา 3–7 วันทำการตามความหนา" },
  { q: "moj certified translator for arrest warrant or court summons", a: "An MoJ-registered translator can certify an arrest warrant, summons, or judgment for foreign execution. NYC delivers the certified set in three to seven working days from THB 900 per page and can chain MFA legalisation for the destination court." },
  { q: "naati translation for partner visa chat evidence", a: "Australian partner-visa relationship evidence — chat logs, remittance slips, joint bills — must be NAATI-certified when not in English. NYC bundles a 20-page evidence pack from THB 4,900 with the NAATI stamp and digital verification code." },

  // ── Notarial services & legalization chains ────────────────────────
  { q: "ค่ารับรองลายมือชื่อโดยทนาย Notary Public เท่าไหร่", a: "ทนายรับรองลายมือชื่อ ฿1,000–1,500 ต่อฉบับ · รับรองสำเนาถูกต้อง ฿800 · ร่างและรับรอง Affidavit ฿2,500–4,000 · รับรองลายมือชื่อกรรมการชุดประมูลงานต่างประเทศ ทำได้ภายในวันเดียวหากนัดล่วงหน้า" },
  { q: "certified true copy of foreign passport for overseas bank account", a: "A Thai Notarial Services Attorney can certify a true copy of your foreign passport for opening an overseas bank or brokerage account. NYC issues it the same day from THB 800 per page, with courier despatch worldwide via DHL." },
  { q: "notarize bilingual power of attorney same day thailand", a: "Yes. NYC drafts a Thai–English power of attorney to your bank or land-office wording, has it notarised the same afternoon, and can chain MFA plus embassy legalisation within four to six working days. Drafting plus notarisation from THB 4,500." },
  { q: "รับรองใบอนุญาตแพทยสภา สภาวิศวกร ไปใช้ต่างประเทศ", a: "ขั้นตอนคือ ขอหนังสือรับรองจากสภาวิชาชีพ → แปลรับรอง → นิติกรณ์กรมการกงสุล → สถานทูตปลายทางหรือ Apostille NYC เดินเรื่องครบสาย ใช้เวลารวม 7–12 วันทำการ เริ่ม ฿6,500 ต่อชุด" },
  { q: "legalize corporate documents at the chinese or uae embassy", a: "For China or the UAE the chain is certified translation, MFA Chaeng Watthana legalisation, then embassy attestation. NYC runs all three, typically seven to ten working days, and returns hard copies with the receipt trail for your auditors." },

  // ── One-stop B2B / expat packages ──────────────────────────────────
  { q: "เปิดบริษัทไทย จดทะเบียน เปิดบัญชี ใช้เวลากี่วัน", a: "จองชื่อ 1 วัน · จดทะเบียนบริษัทที่ DBD 1–3 วัน · ขอเลข VAT 3–7 วัน · เปิดบัญชีนิติบุคคล 3–10 วันขึ้นกับธนาคาร รวมทั้งชุดประมาณ 10–15 วันทำการ NYC จัดล่ามและเอกสารสองภาษาให้ทุกขั้นตอน" },
  { q: "us treaty of amity 100 percent foreign owned company", a: "American citizens and US-majority corporations can hold 100% of a Thai company under the Treaty of Amity. NYC prepares the certification file for the Commercial Service and DBD registration together; the certification step alone takes about three to four weeks." },
  { q: "turnkey package boi company visa work permit", a: "NYC's turnkey investor package covers BOI application, company registration, Non-B visas, and work permits for the foreign expert team, with a single project manager and bilingual document set. Scope and pricing are quoted after a free requirements call." },
  { q: "ต่อวีซ่าและใบอนุญาตทำงานล่วงหน้า ป้องกัน overstay", a: "NYC ตั้งปฏิทินเตือนที่ T-60, T-30 และ T-14 วัน เตรียมเอกสารบริษัท ภ.ง.ด.1 ประกันสังคม และงบการเงินให้ครบก่อนถึงคิว ลดความเสี่ยง overstay ปรับวันละ ฿500 สูงสุด ฿20,000" },
  { q: "abtc apec business travel card fast track airports", a: "An ABTC gives Thai executives visa-free entry to 19 APEC economies and access to the dedicated APEC lanes at Suvarnabhumi, Don Mueang, and most member-economy hubs. NYC handles the FTI or Board of Trade endorsement and the immigration filing." },
  { q: "tat travel agency licence security deposit", a: "A TAT licence needs a security deposit banded by scope: domestic, inbound, and outbound tiers each carry different bond amounts, plus office proof and a qualified manager. NYC prepares the bond, licence file, Non-B visas, and VAT registration together." },
  { q: "ขอ อย. นำเข้าเครื่องสำอางและอาหารเสริม ทำยังไง", a: "ต้องมีนิติบุคคลไทย สถานที่เก็บผ่านตรวจ และเอกสารผู้ผลิตต่างประเทศที่รับรองกงสุลแล้ว NYC แปลและรับรอง Free Sale Certificate, GMP และ CoA ครบชุด แล้วยื่นจดแจ้งผ่านระบบ e-Submission ของ อย." },
  { q: "madrid protocol global trademark registration thailand", a: "Thailand is a Madrid Protocol member, so one international application filed through DIP can designate multiple countries. NYC prepares the base mark filing, the MM2 designation set, and certified translations of any priority documents." },
  { q: "residence certificate for buying a car or thai driving licence", a: "Immigration or your embassy can issue a residence certificate. Immigration is free but slower; NYC books the queue, prepares TM30 proof and lease evidence, and escorts you — usually one appointment plus a three to five working-day collection." },
  { q: "บริการยื่นภาษีเงินได้บุคคลธรรมดาสำหรับชาวต่างชาติ", a: "NYC ช่วยชาวต่างชาติยื่น ภ.ง.ด.91/90 คำนวณเครดิตภาษีตามอนุสัญญาภาษีซ้อน ขอหนังสือรับรองถิ่นที่อยู่ (R.O.21) และหนังสือรับรองการหักภาษี (R.O.22) สำหรับใช้ยื่นภาษีในประเทศต้นทาง" },
  { q: "single status certificate notarized and couriered to australia", a: "NYC obtains the Certificate of Single Status from your district office, translates and certifies it, adds notarisation or MFA legalisation as required, and ships door-to-door by DHL — typically six to nine working days end to end." },
  ...PROPERTY_INHERITANCE_FAQS,
  ...FINANCE_TAX_FAQS,
  ...LABOUR_HR_FAQS,
  ...LITIGATION_POA_FAQS,
  ...LOGISTICS_CUSTOMS_FAQS,
  ...IT_IP_FAQS,
  ...ENERGY_CONSTRUCTION_INSURANCE_FAQS,
  ...EDUCATION_MEDICAL_FAQS,
  ...AGRI_TOURISM_MEDIA_FAQS,
  ...MARITIME_AVIATION_FAQS,
  ...ISLAMIC_NGO_SPORTS_FAQS,
  ...CITIZENSHIP_PR_FAMILY_FAQS,
  ...PROPERTY_CHEM_MINING_FAQS,
  ...AUTOMOTIVE_TRANSPORT_FAQS,
  ...RETAIL_ECOMMERCE_FAQS,
  ...GOV_PROCUREMENT_FAQS,
  ...PROVINCIAL_SERVICE_FAQS,
  ...POLICE_CLEARANCE_FAQS,
  ...MARRIAGE_FAMILY_ABROAD_FAQS,
  ...PDPA_DIGITAL_ASSET_FAQS,
  ...CIVILREG_INSURANCE_TELECOM_FAQS,
  ...LANGUAGE_TRAINING_INTERPRETING_FAQS,
  ...EMBASSY_COUNTRY_DESK_FAQS,
  ...VISA_LONGSTAY_FAQS,
  ...TRANSLATION_DOCTYPE_FAQS,
  ...IT_IP_TECH_FAQS,
  ...NOTARY_PUBLIC_DEPTH_FAQS,
  ...OVERSEAS_EMPLOYMENT_SEAFARER_FAQS,
  ...EAPOSTILLE_DIGITAL_DOCS_FAQS,
  ...ORDER_PROCESS_QUALITY_FAQS,
  ...THAI_NATIONALS_ABROAD_FAQS,
  ...FOREIGN_RESIDENTS_THAILAND_FAQS,
  ...CREDENTIAL_RECOGNITION_FAQS,
  ...PROVINCIAL_COVERAGE_FAQS,
  ...EGP_PROCUREMENT_DEPTH_FAQS,
  ...CIVILREG_PROPERTY_PDPA_DEPTH_FAQS,
  ...MFA_CONSULAR_DEPTH_FAQS,
  ...LITIGATION_ARBITRATION_DEPTH_FAQS,
  ...LABOUR_HR_WORKPERMIT_DEPTH_FAQS,
  ...IP_PDPA_COMPLIANCE_DEPTH_FAQS,
  ...APOSTILLE_HCCH_COUNTRY_DEPTH_FAQS,
  ...REALESTATE_LANDOFFICE_DEPTH_FAQS,
  ...REGIONAL_PROVINCE_DEPTH_FAQS,
  ...EGP_BID_DOCS_DEPTH_FAQS,
  ...HEALTHCARE_MEDICAL_TOURISM_DEPTH_FAQS,
  ...CHILD_GUARDIANSHIP_ADOPTION_DEPTH_FAQS,
  ...EDUCATION_CREDENTIAL_DEPTH_B_FAQS,
  ...LOGISTICS_CUSTOMS_DEPTH_B_FAQS,
  ...INSURANCE_CLAIMS_DEPTH_FAQS,
  ...PERSONAL_TAX_CUSTOMS_DEPTH_FAQS,
  ...BANKING_FINANCE_KYC_DEPTH_FAQS,
  ...STUDY_ABROAD_ADMISSION_DEPTH_FAQS,
  ...CIVILREG_TELECOM_DEPTH_FAQS,
  ...PROPERTY_MINING_CHEM_DEPTH_FAQS,
  ...RETAIL_FRANCHISE_MEDIA_DEPTH_FAQS,
  ...ENERGY_CONSTRUCTION_DEPTH_FAQS,
  ...LITIGATION_COURT_DEPTH_B_FAQS,
  ...LABOUR_HR_DEPTH_B_FAQS,
  ...CIVILREG_PROPERTY_DEPTH_B_FAQS,
  ...IP_PDPA_DEPTH_B_FAQS,
  ...MFA_CONSULAR_DEPTH_B_FAQS,
  ...CORPORATE_BOI_DEPTH_B_FAQS,
  ...RETAIL_MEDIA_DEPTH_B_FAQS,
  ...INSURANCE_CLAIMS_DEPTH_B_FAQS,
  ...TAX_CUSTOMS_DEPTH_B_FAQS,
  ...MARITIME_AVIATION_DEPTH_B_FAQS,
  ...DRIVING_TRANSPORT_DEPTH_B_FAQS,
  ...POLICE_CLEARANCE_DEPTH_B_FAQS,
  ...MARRIAGE_FAMILY_DEPTH_B_FAQS,
  ...REALESTATE_LAND_DEPTH_B_FAQS,
  ...MEDICAL_HEALTH_DEPTH_B_FAQS,
  ...BANKING_FINANCE_DEPTH_B_FAQS,
  ...ENERGY_CONSTRUCTION_DEPTH_C_FAQS,
  ...MINING_CHEMICALS_DEPTH_C_FAQS,
  ...EGP_PROCUREMENT_DEPTH_C_FAQS,
  ...LOGISTICS_CUSTOMS_DEPTH_C_FAQS,
  ...EDUCATION_CREDENTIAL_DEPTH_C_FAQS,
  ...TELECOM_DIGITAL_DEPTH_C_FAQS,
  ...NOTARY_CORE_DEPTH_C_FAQS,
  ...APOSTILLE_HCCH_DEPTH_C_FAQS,
  ...CERTIFIED_TRANSLATION_NAATI_DEPTH_C_FAQS,
  ...POLICE_CLEARANCE_DEPTH_C_FAQS,
  ...VISA_IMMIGRATION_DEPTH_C_FAQS,
  ...MARRIAGE_FAMILY_DEPTH_C_FAQS,
  ...CIVIL_REGISTRATION_DEPTH_C_FAQS,
  ...REALESTATE_LAND_DEPTH_C_FAQS,
  ...LITIGATION_ARBITRATION_DEPTH_C_FAQS,
  ...MEDICAL_HEALTH_DEPTH_C_FAQS,
  ...BANKING_KYC_DEPTH_C_FAQS,
  ...INSURANCE_CLAIMS_DEPTH_C_FAQS,
  ...SERVICE_PROCEDURE_PLAYBOOK_FAQS,
  ...TAX_CUSTOMS_DEPTH_C_FAQS,
  ...LABOUR_HR_DEPTH_C_FAQS,
  ...EDUCATION_CREDENTIAL_DEPTH_D_FAQS,
  ...SERVICE_PROCEDURE_PLAYBOOK_B_FAQS,
  ...NAATI_DEPTH_D_FAQS,
  ...PROVINCIAL_SERVICE_DEPTH_B_FAQS,
  ...EGP_PROCUREMENT_DEPTH_D_FAQS,
  ...NAATI_DEPTH_E_FAQS,
  ...NAATI_DEPTH_F_FAQS,
  ...PROVINCIAL_SERVICE_DEPTH_D_FAQS,
  ...PROPERTY_MINING_CHEM_DEPTH_B_FAQS,
  ...PROVINCIAL_SERVICE_DEPTH_C_FAQS,
  ...EGP_PROCUREMENT_DEPTH_E_FAQS,
  ...EGP_PROCUREMENT_DEPTH_F_FAQS,
  ...SERVICE_PROCEDURE_PLAYBOOK_C_FAQS,
  ...LOGISTICS_CUSTOMS_DEPTH_D_FAQS,
  ...INSURANCE_CLAIMS_DEPTH_D_FAQS,
  ...LITIGATION_ARBITRATION_DEPTH_D_FAQS,
  ...MEDICAL_HEALTH_DEPTH_D_FAQS,
  ...BANKING_KYC_DEPTH_D_FAQS,
  ...TELECOM_DIGITAL_DEPTH_D_FAQS,
  ...TAX_CUSTOMS_DEPTH_D_FAQS,
  ...LABOUR_HR_DEPTH_D_FAQS,
  ...NOTARY_CORE_DEPTH_D_FAQS,
  ...APOSTILLE_HCCH_DEPTH_D_FAQS,
  ...VISA_IMMIGRATION_DEPTH_D_FAQS,
  ...MARRIAGE_FAMILY_DEPTH_D_FAQS,
  ...CORPORATE_BOI_DEPTH_D_FAQS,
  ...EDUCATION_CREDENTIAL_DEPTH_E_FAQS,
  ...POLICE_CLEARANCE_DEPTH_D_FAQS,
  ...IP_TRADEMARK_DEPTH_D_FAQS,
  ...FRANCHISE_DISTRIBUTION_DEPTH_D_FAQS,
  ...ENERGY_RENEWABLES_DEPTH_D_FAQS,
  ...MARITIME_SHIPPING_DEPTH_D_FAQS,
  ...AVIATION_AEROSPACE_DEPTH_D_FAQS,
  ...NONPROFIT_NGO_DEPTH_D_FAQS,
  ...SPORTS_ESPORTS_DEPTH_D_FAQS,
  ...AGRICULTURE_FOOD_DEPTH_D_FAQS,
  ...STARTUP_VC_DEPTH_D_FAQS,
  ...MEDIA_ENTERTAINMENT_DEPTH_D_FAQS,
  ...MINING_RESOURCES_DEPTH_D_FAQS,
  ...CONSTRUCTION_FIDIC_DEPTH_D_FAQS,
  ...INSURANCE_REINSURANCE_DEPTH_E_FAQS,
  ...REAL_ESTATE_FOREIGN_DEPTH_D_FAQS,
  ...CUSTOMS_FTA_DEPTH_D_FAQS,
  ...TEXTILE_APPAREL_DEPTH_D_FAQS,
  ...WASTE_RECYCLING_DEPTH_D_FAQS,
  ...WATER_UTILITIES_DEPTH_D_FAQS,
  ...SPACE_SATELLITE_DEPTH_D_FAQS,
  ...PORTS_FTZ_DEPTH_D_FAQS,
  ...RAIL_TRANSPORT_DEPTH_D_FAQS,
  ...FISHERIES_AQUA_DEPTH_D_FAQS,
  ...DEFENSE_PROCUREMENT_DEPTH_D_FAQS,
  ...SEMICONDUCTOR_CHIP_DEPTH_D_FAQS,
  ...FORESTRY_TIMBER_DEPTH_D_FAQS,
];
